export default "__VITE_ASSET__CnOS1R1l__"